// extracted by mini-css-extract-plugin
module.exports = {"background":"CircleBackground-mobile_background__3q47r","overlay":"CircleBackground-mobile_overlay__1-sNh"};